//gatsby-node.js에서 사용할 때 ES6의 import가 먹지 않음. require로 처리해야함. 포멧 유지
exports.dynamicRoutePages = [
    { uri: '/helpdoc/', paramNames: ['path1', 'path2', 'path3', 'path4', 'path5'] },
]
